import React from 'react';

import { Form } from 'antd';
import styled from 'styled-components';

import SnapshotDetails from './SnapshotDetails';
import { useCommunityViewContext } from '../../../CommunityViewContext';
import { useResolveQuarterSnapshots } from '../customHooks';
import { useDataQuarterFilterContext } from '../DataQuarterFilterContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled.span`
  font-family: var(--font-bold);
  font-size: 12px;
  text-transform: uppercase;
  color: var(--text-primary);
`;

const NoDataLabel = styled.span`
  color: var(--text-secondary);
  font-size: 14px;
`;

const MyCommunitySection = () => {
  const { form, quarters } = useDataQuarterFilterContext();
  const selectedQuarterSlug = Form.useWatch('selectedQuarterSlug', form) ?? quarters[0]?.slug ?? null;
  const { competitors } = useCommunityViewContext();
  const { communityMatch } = useResolveQuarterSnapshots({
    quarters,
    selectedQuarterSlug,
    competitors,
  });

  const snapshot = communityMatch?.snapshot;
  const label = communityMatch ? (communityMatch.isCurrentQuarter ? 'Selected update' : 'Prior update') : undefined;

  return (
    <Container>
      <Title>My Community Update</Title>
      {snapshot && label ? (
        <SnapshotDetails snapshot={snapshot} label={label} />
      ) : (
        <NoDataLabel>No data available</NoDataLabel>
      )}
    </Container>
  );
};

export default MyCommunitySection;
